import ApiService from "@/core/services/api.service";
import SanctumService from "@/core/services/sanctum.service";
// import store from "@/core/services/store";
import { UPDATE_PERSONAL_INFO, UPDATE_ADMIN_INFO } from "@/core/services/store/profile.module";
import router from '@/router'; // Adjust path if needed
import { authGet, authSet, authRemove, clearAuthStorage } from "@/core/services/auth-storage";

// action types
export const VERIFY_AUTH = "verifyAuth";
export const LOGIN = "login";
export const IMPERSONATE = "inpersonate"
export const END_IMPERSONATION = 'end_inpersonate'
export const UPDATE_AUTH = "update_auth";
export const LOGOUT = "auth/logout";
export const REGISTER = "signup";
export const UPDATE_PASSWORD = "updateUser";
export const SET_COOKIE = "setCookie";
export const CLAIM_BUSINESS = 'claim_business';

// mutation types
export const PURGE_AUTH = "logOut";
export const SET_AUTH = "setUser";
export const SET_PASSWORD = "setPassword";
export const FORGOT_PASSWORD = "forgotPassword";
export const RESET_PASSWORD = "resetPassword";
export const SET_ERROR = "setError";
export const CLEAR_AUTH_ERRORS = "clearAuthErrors";
export const SET_IMPERSONATING = "setImpersonating"

function readStoredAuthState() {
  try {
    const raw = authGet("USER_STATE");
    if (!raw) {
      return null;
    }
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") {
      return null;
    }
    return {
      errors: null,
      user: parsed.user || {},
      isAuthenticated: !!parsed.isAuthenticated,
      // Business users must not flash as Super Admin before VERIFY_AUTH
      normal: !!parsed.normal,
      currency: parsed.currency || "£",
      isImpersonating: authGet("is_impersonating") === "true",
    };
  } catch (e) {
    return null;
  }
}

const storedAuth = readStoredAuthState();
const state = storedAuth || {
  errors: null,
  user: {},
  isAuthenticated: false,
  normal: false,
  currency: "£",
  isImpersonating: authGet("is_impersonating") === "true",
};

const getters = {
  isImpersonating(state) {
    return state.isImpersonating
  },
  currentUser(state) {
    // var userAuth = sessionStorage.getItem('USER_STATE');
    // if (userAuth) {

    //   let authParsed = JSON.parse(userAuth);
    //   return authParsed.user;
    // }
    return state.user;
  },
  isAuthenticated(state) {
    // let userAuth = sessionStorage.getItem('USER_STATE');
    // if (userAuth) {

    //   let authParsed = JSON.parse(userAuth);
    //   return authParsed.isAuthenticated;
    // }
    return state.isAuthenticated;
  }
};

const actions = {

  [UPDATE_AUTH](context) {
    let userAuth = authGet('USER_STATE');
    if (userAuth) {
      let authParsed = JSON.parse(userAuth);

      context.commit(SET_AUTH, authParsed);
    }
  },
  [LOGIN](context, credentials) {
    return new Promise((resolve, reject) => {
      ApiService.post(LOGIN, credentials)
        .then(({ data }) => {
          console.log('data.data' + JSON.stringify(data.data));
          if (data.data.token) {
            authSet('is_superAdmin', data.data.orders == '-1' ? 1 : 0)
            console.log('is_superAdmin', data.data.orders == '-1' ? 1 : 0)
            authSet("ID_TOKEN", data.data.token);
            authSet("BRANCHES_COUNT", data.data.user.branches_count);
            authSet("SELECTED_BRANCH", 0);
            const main_branch = data.data.user.business;
            authSet("MAIN_BRANCH", JSON.stringify(main_branch));

            if (data.data.staff) {
              authSet('is_staff', 1); // Save staff flag
              authSet('staff', JSON.stringify(data.data.staff)); // Store staff ID
              authSet('staff_id', data.data.staff.id); // Store staff ID
              if (data.data.staff.permissions) {
                const permissions = data.data.staff.permissions.map(perm => ({
                  id: perm.id,
                  name: perm.name
                }));
                authSet('staff_permissions', JSON.stringify(permissions));
              }

            } else {
              authSet('is_staff', 0);
            }

            // Handle agent user type
            if (data.data.user && data.data.user.user_type === 'AGENT') {
              authSet('is_agent', 1); // Save agent flag
              authSet('agent', JSON.stringify(data.data.user)); // Store agent data
              authSet('agent_id', data.data.user.id); // Store agent ID
              console.log('Agent user detected:', data.data.user);
              if (data.data.user.permissions) {
                const permissions = data.data.user.permissions.map(perm => ({
                  id: perm.id,
                  name: perm.name
                }));
                authSet('agent_permissions', JSON.stringify(permissions));
              }
            } else {
              authSet('is_agent', 0);
            }
            if (data.data.subscription) {
              authSet('subscription', JSON.stringify(data.data.subscription));
            } else {
              authSet('subscription', '{}');
            }
            // Save enable_room_reservations setting
            if (data.data.enable_room_reservations !== undefined) {
              authSet('enable_room_reservations', data.data.enable_room_reservations);
            }

            // Set role immediately so Layout/Menu don't flash Super Admin sidebar
            const isAgent = !!(data.data.user && data.data.user.user_type === 'AGENT');
            const isAdmin = data.data.orders == -1 || data.data.orders == '-1';
            const userAuth = {
              errors: {},
              user: data.data.user || data.data,
              isAuthenticated: true,
              normal: isAgent ? false : !isAdmin,
              currency: data.data.currency || (data.data.user && data.data.user.currency) || '£',
            };
            context.commit(SET_AUTH, userAuth);
            authSet('USER_STATE', JSON.stringify(userAuth));
          }
          context.dispatch(VERIFY_AUTH);
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response)
          context.commit(SET_ERROR, response.data.errors);
        });
    });
  },

  [IMPERSONATE](context, userId) {
    return new Promise((resolve, reject) => {
      ApiService.post('/login', { impersonate_user_id: userId })
        .then(({ data }) => {
          console.log('Impersonation response data:', JSON.stringify(data));

          if (data.data.token) {
            const alreadyImpersonating = authGet('is_impersonating') === 'true';
            if (!alreadyImpersonating) {
              authSet('ADMIN_TOKEN', authGet('ID_TOKEN'));
              const adminState = authGet('USER_STATE');
              if (adminState) {
                authSet('ADMIN_USER_STATE', adminState);
              }
            }

            authSet('impersonation_token', data.data.token);
            authSet('is_impersonating', 'true');
            authSet('is_superAdmin', 0);
            authSet("ID_TOKEN", data.data.token);
            authSet("BRANCHES_COUNT", data.data.user.branches_count);
            authSet("SELECTED_BRANCH", 0);
            if (data.data.subscription) {
              authSet('subscription', JSON.stringify(data.data.subscription));
            } else {
              authSet('subscription', '{}');
            }
            const main_branch = data.data.user.business;
            authSet("MAIN_BRANCH", JSON.stringify(main_branch));
            context.commit(SET_IMPERSONATING, true);

            const impersonatedAuth = {
              errors: {},
              user: data.data.user || data.data,
              isAuthenticated: true,
              normal: true,
              currency: data.data.currency || (data.data.user && data.data.user.currency) || '£',
            };
            context.commit(SET_AUTH, impersonatedAuth);
            authSet('USER_STATE', JSON.stringify(impersonatedAuth));

            context.dispatch(UPDATE_PERSONAL_INFO, null, { root: true });
            context.dispatch(VERIFY_AUTH);
            resolve(data.data);

          }
        })
        .catch(({ response }) => {
          console.error('Impersonation error:', response);
          context.commit('SET_ERROR', response.data.errors);
          reject(response);
        });
    });
  },
  [END_IMPERSONATION](context) {
    return new Promise((resolve, reject) => {
      const adminToken = authGet('ADMIN_TOKEN');
      if (!adminToken) {
        reject(new Error('Admin session is missing. Please sign in again.'));
        return;
      }

      authSet('ID_TOKEN', adminToken);
      authRemove('impersonation_token');
      authRemove('is_impersonating');
      authSet('is_superAdmin', 1);
      authRemove('MAIN_BRANCH');
      authRemove('BRANCHES_COUNT');
      authRemove('SELECTED_BRANCH');
      authRemove('packages_enabled');
      authRemove('enable_room_reservations');
      try {
        sessionStorage.removeItem('personalInfo');
      } catch (e) {
        // ignore
      }

      let restored = null;
      try {
        restored = JSON.parse(authGet('ADMIN_USER_STATE') || 'null');
      } catch (e) {
        restored = null;
      }
      if (!restored || typeof restored !== 'object') {
        restored = {
          errors: {},
          user: {},
          isAuthenticated: true,
          normal: false,
          currency: '£',
        };
      }
      restored.normal = false;
      restored.isAuthenticated = true;

      context.commit(SET_AUTH, restored);
      authSet('USER_STATE', JSON.stringify(restored));
      context.commit(SET_IMPERSONATING, false);
      context.dispatch(VERIFY_AUTH);
      resolve(true);
    });
  },

  [CLAIM_BUSINESS](context, form) {
    return new Promise((resolve, reject) => {
      ApiService.post('claim-your-business', form)
        .then(({ data }) => {
          console.log(data.data);

          resolve(data);
        })
        .catch(({ response }) => {
          reject(response)
          context.commit(SET_ERROR, response.data.errors);
        });
    });
  },
  [LOGOUT](context) {
    return new Promise((resolve, reject) => {
      ApiService.post(LOGOUT)
        .then(({ data }) => {
          context.commit(PURGE_AUTH);
          resolve(data);
        })
        .catch(({ response }) => {
          console.log('response', response);
          if (!response || !response.response) {
            context.commit(SET_ERROR, { message: 'Server not responding. Please try again later.' });
          } else if (response.data && response.data.errors) {
            context.commit(SET_ERROR, response.data.errors);
          }
          // Always resolve so callers never hang (e.g. when user wasn't logged in)
          resolve();
        });
    });
  },
  [CLEAR_AUTH_ERRORS](context) {
    context.commit(SET_ERROR, null);
  },
  [REGISTER](context, credentials) {
    return new Promise(resolve => {
      ApiService.post(REGISTER, credentials)
        .then(({ data }) => {
          context.commit(SET_AUTH, data.data);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, response.data.errors);
        });
    });
  },
  [VERIFY_AUTH](context) {
    console.log("before verify");

    ApiService.get("user")
      .then(data => {
        console.log("after verify");

        // Determine login type and user type
        const isAgent = data.data.user_type === 'AGENT';
        const isSuperAdmin = data.data.orders == -1;

        // For agent users, treat them like super admin (not normal users)
        const loginType = isAgent ? false : (data.data.orders == -1 ? false : true);

        // Update isImpersonating based on the orders value
        // state.isImpersonating = data.data.orders == 1 ? false : true;

        // Create userAuth object
        const userAuth = {
          errors: {},
          user: data.data,
          isAuthenticated: true,
          normal: isAgent ? false : (data.data.orders == -1 ? false : true),
          currency: data.data.currency,
        };

        authSet('is_superAdmin', isSuperAdmin && !isAgent ? 1 : 0);

        // Handle agent user type in session storage
        if (isAgent) {
          authSet('is_agent', 1);
          authSet('agent', JSON.stringify(data.data));
          authSet('agent_id', data.data.id);
          console.log('Agent user verified:', data.data);
          if (data.data.permissions) {
            const permissions = data.data.permissions.map(perm => ({
              id: perm.id,
              name: perm.name
            }));
            authSet('agent_permissions', JSON.stringify(permissions));
          }
        } else {
          authSet('is_agent', 0);
        }

        // Dispatch appropriate actions based on loginType
        if (loginType) {
          context.dispatch(UPDATE_PERSONAL_INFO);
        } else {
          context.dispatch(UPDATE_ADMIN_INFO, data.data);
        }

        // Commit authentication state
        context.commit(SET_AUTH, userAuth);

        // Persist auth state
        authSet('USER_STATE', JSON.stringify(userAuth));

        // Save enable_room_reservations if present in user data
        if (data.data.enable_room_reservations !== undefined) {
          authSet('enable_room_reservations', data.data.enable_room_reservations);
        }

      })
      .catch(anything => {
        console.log("later verify", anything);

        router.push({ name: 'login' }); // 👈 redirect from inside Vuex (not recommended)

        // context.commit(SET_ERROR, 'Unauthorized');
        // context.commit(PURGE_AUTH);
        throw anything; // ✅ now this works
      });

  },

  [SET_COOKIE]() {
    ApiService.setCookie();
  },
  [UPDATE_PASSWORD](context, payload) {

    return ApiService.post("password", payload).then(({ data }) => {
      context.commit(SET_PASSWORD, data.data);
      return data;
    });
  },

  [FORGOT_PASSWORD](context, payload) {
    const email = payload;

    return ApiService.post("forgot-password", email).then(({ data }) => {
      return data;
    });
  },

  [RESET_PASSWORD](context, payload) {
    const email = payload;

    return ApiService.post("reset-password", email).then(({ data }) => {
      return data;
    });
  }

};

const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error;
  },
  [SET_IMPERSONATING](state, bol) {
    state.isImpersonating = bol;
  },

  [SET_AUTH](state, user) {
    state.isAuthenticated = user.isAuthenticated;
    state.user = user.user;
    state.errors = {};
    state.normal = user.normal
    state.currency = user.currency;
    // if (user.token) {
    //   sessionStorage.setItem("ID_TOKEN" , user.token)
    // }
    //state = user;
  },
  // [SET_AUTH_FROM_SESSION](state, payload) {
  //   state = payload;
  // },

  [SET_PASSWORD](state, password) {
    state.user.password = password;
  },
  [PURGE_AUTH](state) {
    state.isAuthenticated = false;
    state.user = {};
    state.errors = {};
    state.normal = false;
    clearAuthStorage();
    authSet('USER_STATE', JSON.stringify({
      isAuthenticated: false,
      user: {},
      errors: {},
      normal: false,
    }));
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
